import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { User } from "shared/api";
import { useSidebarData } from "shared/hooks";
import { AddDashboardModal } from "./ui/AddDashboardModal";
import { MinimizedSidebar, SidebarHeader, SidebarMenu } from "./ui";

interface SidebarProps {
  isOpenSidebar?: boolean;
  dynamicPageId?: string | undefined;
  getPersonalInfo?: User;
}

const Sidebar: FC<SidebarProps> = ({
  isOpenSidebar,
  dynamicPageId,
  getPersonalInfo,
}) => {
  const { pathname } = useLocation();
  const [themeColor, setThemeColor] = useState("#002F5F");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("color-theme");
      if (stored) {
        setThemeColor(JSON.parse(stored));
      }
    } catch {
      setThemeColor("#002F5F");
    }
  }, []);

  const {
    minimizedSidebar,
    closeMinimizedSidebar,
    openMinimizedSidebar,
    isVisibleAddDashboardModal,
    hideDashboardModal,
    selectMenuKeys,
    handleActiveLink,
    filteredSidebarItems,
  } = useSidebarData({ pathname, getPersonalInfo });

  if (minimizedSidebar) {
    return <MinimizedSidebar closeMinimizedSidebar={closeMinimizedSidebar} />;
  }

  if (!dynamicPageId && !isOpenSidebar) {
    return null;
  }

  return (
    <div
      className={classNames(
        "w-60 h-screen sticky  pb-7 top-0  shadow-sidebar  transition-transform duration-300 sidebar"
      )}
      style={{ backgroundColor: themeColor }}
    >
      <SidebarHeader openMinimizedSidebar={openMinimizedSidebar} />

      <div className="h-90% flex flex-col justify-between mt-5 sidebar">
        <SidebarMenu
          handleActiveLink={handleActiveLink}
          pathname={pathname}
          translatedSidebarItems={filteredSidebarItems}
          selectMenuKeys={selectMenuKeys}
        />
      </div>

      <AddDashboardModal
        isOpen={isVisibleAddDashboardModal}
        onClose={hideDashboardModal}
      />
    </div>
  );
};

const SidebarMemo = React.memo(Sidebar);

export { SidebarMemo as Sidebar };
